import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { ModeFormValues } from 'src/models/Mode.model';
import ATMSwitchButton from 'src/components/UI/atoms/formFields/ATMSwitchButton/ATMSwitchButton';

type Props = {
  formikProps: FormikProps<ModeFormValues>;
  onClose: () => void;
  formType?: "ADD" | "EDIT";

};

const ModeForm = ({ formType, formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='flex flex-col gap-6 p-4'>
      <div className='flex items-center justify-between'>
        <div className='text-xl font-medium'>{formType === "EDIT" ? "Update Mode" : "Add Mode"}</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        {/* Mode Name */}
        <div >
          <ATMTextField
            name='modeName'
            value={values?.modeName}
            onChange={(e) => setFieldValue('modeName', e.target.value)}
            label='Mode Name'
            placeholder='Enter Mode Name'
            onBlur={handleBlur}
          />
        </div>
        {/* Mode Description */}
        <div >
          <ATMTextField
            name='modeDescription'
            value={values.modeDescription}
            onChange={(e) => setFieldValue('modeDescription', e.target.value)}
            label='Mode Description'
            placeholder='Enter Mode Description'
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMSwitchButton
            name="isVirtual"
            value={values.isVirtual}
            onChange={(newValue) => setFieldValue("isVirtual", newValue)}
            label="Is-Virtual"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ModeForm;